import { render, staticRenderFns } from "./SearchExchangeTransactionHeader.vue?vue&type=template&id=0727d636&"
import script from "./SearchExchangeTransactionHeader.vue?vue&type=script&lang=js&"
export * from "./SearchExchangeTransactionHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchExchangeTransactionHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports